// ShopHelten - Terms & Conditions checkbox at the cart
$(document).ready(function () {
    $("body").on(
        "click",
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
        function () {
            if ($("#agree").is(":checked") || $("#agree_main_cart").is(":checked")) {
                $(this).submit();
            } else {
                alert(
                    "You must accept the terms & conditions."
                );
                return false;
            }
        }
    );

  // Custom for this theme's "Slide-in" cart
   $('[name="checkout-link"]').click((event) => {
     event.preventDefault();

     if ($("#agree").is(":checked") || $("#agree_main_cart").is(":checked")) {
         window.location.href = $(event.target).attr("href");
      } else {
          alert(
              "You must accept the terms & conditions."
          );
          return false;
      }
   });

  // Click handler for switching between variants
  $('body').on(
    "click",
    'button.product__chip',
    function (evt) {
      // Hide all SKU and Barcode/EAN
      $(".product__barcode").hide();

      // Now show selected variant's SKU and Barcode/EAN
      var barcode = $(evt.currentTarget).data("barcode");
      console.log("target", $(evt.currentTarget));
      $(`.barcode-${barcode}`).show();
    }
  );
});